import onGetClinicShelters from './onGetClinicShelters';
import onGetClinicShelter from './onGetClinicShelter';
import onArchiveShelter from './onArchiveShelter';
import onCreateShelter from './onCreateShelter';
import onRestoreShelter from './onRestoreShelter';
import onUpdateShelter from './onUpdateShelter';
import onGetAvailableShelters from './onGetAvailableShelters';

export default {
  onGetClinicShelters,
  onGetClinicShelter,
  onArchiveShelter,
  onRestoreShelter,
  onCreateShelter,
  onUpdateShelter,
  onGetAvailableShelters,
};
